const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const NUMBERS = '0123456789';
const SPECIAL = '!@#$%&*?';

export function generatePassword(length = 12): string {
  const allChars = UPPERCASE + LOWERCASE + NUMBERS + SPECIAL;

  // Ensure at least one of each type
  const required = [
    UPPERCASE[Math.floor(Math.random() * UPPERCASE.length)],
    LOWERCASE[Math.floor(Math.random() * LOWERCASE.length)],
    NUMBERS[Math.floor(Math.random() * NUMBERS.length)],
    SPECIAL[Math.floor(Math.random() * SPECIAL.length)],
  ];

  const remaining = Array.from(
    { length: length - required.length },
    () => allChars[Math.floor(Math.random() * allChars.length)],
  );

  // Shuffle all characters together
  const password = [...required, ...remaining];
  for (let i = password.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join('');
}
